// extracted by mini-css-extract-plugin
module.exports = {"partners":"Partners_partners__Pud3k","partners__fig":"Partners_partners__fig__aegaI","partners__img":"Partners_partners__img__2nY7B","hero-section":"Partners_hero-section__Y_7PL"};